module.exports = __webpack_public_path__ + "static/media/FeedTime_ios_1_preview.779b93d4.jpg";